import { ColDef, GridApi } from "ag-grid-community";
import _, { isEqual } from "lodash";
import moment from "moment";
import LeadExportService from "../../../services/LeadExportService";



import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useCallback,  
  useMemo
} from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  setLeadCount,
  setLeadFilter,
  setLeadIds,
  updateSingleLead,
  userPreferences,
} from "../../../actions/actions";
import {
  assignLeadInList,
  copyLeadInList,
  deleteBulkLeads,
  filterLeads,
  getAllLeads,
  moveLeadInList,
  putUserPreferences,
  updateLead,
} from "../../../services/leadService";
import DistributionChart from "../DistributionChart/DistributionChart";
import PopupComponent from "../../../components/PopupComponent";
import { areAllValuesUndefined } from "../../../utils/helpers";
import AgGrid, { IFetchRowsParams } from "../../common/grid/AgGrid";
import { CustomFieldsT } from "../customLeadForm";
import {
  assignedToRenderer,
  dateRenderer,
  labelRenderer,
  lastActivityRenderer,
  locationRenderer,
  nameRenderer,
  dateTimeRenderer,
  phoneRenderer,
  sourceRenderer,
  statusRenderer,
  saleValueRenderer, 
  campaignNameRenderer,
  formNameRenderer,
  phoneRendererTest, 
  createdByRenderer,
  editableCustomFieldRenderer,
  urlRenderer,
  addressRenderer,
} from "./leads-renderers";
import { FilterParams, advanceFilterKeys } from "./leads.types";
import ContactLinksGenerator from "../../../utils/contactlinksgenerator";
import TaskDrawer from "../../common/TaskDrawer";
import CreateTaskForm from "../../../components/createTaskForm";
import CreateLeadDetailsTaskForm from "../../../components/createLeadTaskForm";
import CreateNoteForm from "../../../components/createNoteForm";
import { MdAddTask } from "react-icons/md";
import { MdOutlineNoteAdd } from "react-icons/md";
import BulkSelector from "../../../components/BulkSelector/bulkSelector";
import BulkLeadOptions from "../../../components/BulkLeadOptions/bulkLeadOptions";
import { useNavigate } from "react-router-dom";
import { setManuallyAutomate } from "../../../services/automationService";
import logger, { Logger } from '../../../utils/logger';
import SelectLeadStatus from "../../../components/status";
import SelectLeadLabel from "../../../components/label";
import { ChartLine } from "lucide-react";

import { updateLeadProducts } from "../../../services/leadService";
import MemoizedProductPickerPopup from "../../../components/ProductPickerPopup";
import BulkShareModal from "../../../components/BulkLeadOptions/BulkShareModal";
import { getAllContent } from "../../../services/contentService";
import { store } from "../../../store/store";
import { BaseColumnDefinition, ColumnRegistry, createCustomFieldColumnDef, getAllColumnDefs, getDefaultColumnOrder } from "../../../utils/columnRegistry";
import AssignLeadDrawer from "../../../components/AssignLeadDrawer";
import InlineEditorManager from "../../../components/InlineEditor/InlineEditorManager";
import ColumnFilterDropdown from "../../../components/ColumnFilterDropdown/ColumnFilterDropdown";
import GenericConfirmationModal from "../../../components/GenericConfirmationModal";




export interface PreferenceI {
  status: Array<any>;
  labels: Array<any>;
  leadGridPreferences: {
    columnOrders: string[];
    columnWidths: { [colId: string]: number };
  };
  customForm: Array<CustomFieldsT>;
}

interface ProductWithQuantity {
  _id: string;
  name: string;
  price: number;
  quantity: number;
  // Add other fields as needed
}

export interface ILeadsGridProps {
  handleLeadClick: (rowData: any) => void;
  leadListData: Array<any>;
  setLeadListData: React.Dispatch<React.SetStateAction<any[]>>;
  onEditStatus: () => void;
  onEditLabel: (data?: any) => void; // Make data parameter optional with ?
  selectedItemCount: number;
  setSelectedItemCount: any;
  showBulk: boolean;
  onResetBulk: () => void;
  context?: any; 
  StoreData?: any; // Add access to StoreData
}

const LeadsGrid = forwardRef(
  (
    {
      handleLeadClick,
      leadListData,
      setLeadListData,
      onEditStatus,
      onEditLabel,
      selectedItemCount,
      setSelectedItemCount,
      showBulk,
      context,
      onResetBulk,
    }: ILeadsGridProps,
    ref
  ) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [resetGrid, setResetGrid] = useState<number>(0);
    const [openWithHeader, setOpenWithHeader] = useState<boolean>(false);
    // const [selectedItemCount, setSelectedItemCount] = useState<number>(0);

    const actionColumnClicked = useRef(''); // Store which column was clicked
    const [statusEditLead, setStatusEditLead] = useState<any>(null);
    const [selectedStatus, setSelectedStatus] = useState<string>("");
    const [showStatusPopup, setShowStatusPopup] = useState<boolean>(false);
    const [labelEditLead, setLabelEditLead] = useState<any>(null);
const [selectedLabel, setSelectedLabel] = useState<Array<string>>([]);
const [showLabelPopup, setShowLabelPopup] = useState<boolean>(false);

const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);


const [showAssignDrawer, setShowAssignDrawer] = useState(false);
const [selectedLeadsForAssign, setSelectedLeadsForAssign] = useState<string[]>([]);

// NEW: Track bulk selection mode (manual vs filter-based)
const [isFilterSelectionMode, setIsFilterSelectionMode] = useState(false);
const [showSelectAllConfirmation, setShowSelectAllConfirmation] = useState(false);

const [showDistributionChart, setShowDistributionChart] = useState(false);
const [distributionField, setDistributionField] = useState('');

// Column filter state
const [columnFilters, setColumnFilters] = useState<{[colId: string]: any}>({});
const [columnSort, setColumnSort] = useState<{colId: string; direction: 'asc' | 'desc'} | null>(null);

// Set default column definitions from the registry
const defaultColumnDefs: ColDef[] = getAllColumnDefs();

// Initialize state with default columns
const [columnDefs, setColumnDefs] = useState<ColDef[]>(defaultColumnDefs);

const [showBulkShareModal, setShowBulkShareModal] = useState<boolean>(false);
const [contentTemplates, setContentTemplates] = useState<any[]>([]);
const [selectedLeadsForShare, setSelectedLeadsForShare] = useState<any[]>([]);

const [productPickerOpen, setProductPickerOpen] = useState(false);
const [selectedLeadForProducts, setSelectedLeadForProducts] = useState<any>(null);
const [selectedProducts, setSelectedProducts] = useState<ProductWithQuantity[]>([]);
const [editTrigger, setEditTrigger] = useState<{leadId: string, fieldId: string} | null>(null);

// Inline editor state
const [inlineEditorOpen, setInlineEditorOpen] = useState(false);
const [inlineEditorData, setInlineEditorData] = useState<{
  leadId: string;
  fieldConfig: any;
  currentValue: any;
  targetElement?: HTMLElement | null;
  position?: { top: number; left: number; width: number; height: number };
} | null>(null);

 
useEffect(() => {
  Logger.log('Grid Config:', {
    hasColumnDefs: !!columnDefs?.length,
    defaultColDef: defaultColumnDefs,
    rowSelection: gridApi.current?.getSelectedNodes()
  });
}, []);


useEffect(() => {
  const shouldBeEasyMode = showBulk || selectedItemCount > 0;
  easySelectModeRef.current = shouldBeEasyMode;
  logger.log('Easy select mode auto-set to:', shouldBeEasyMode);
}, [showBulk, selectedItemCount]);

    

    const { filterParam, leadCount } = useSelector(
      (state: any) => state.rootReducers.leads
    );
    const gridApi = useRef<GridApi | null>(null);
    const preferenceRef = useRef<PreferenceI | null>(null);
    const StoreData = useSelector((state: any) => {
      return state?.rootReducers;
    });

    const preferences: PreferenceI = useSelector(
      (state: { rootReducers: { user: { userPreferences: any } } }) =>
        state?.rootReducers?.user?.userPreferences
    );

// In LeadsGrid.tsx
const debouncedColumnMove = useRef(
  _.debounce((newColumnOrder: string[], preferences: PreferenceI) => {
    onColumnOrderChanged && 
      onColumnOrderChanged(newColumnOrder, preferences);
  }, 500)
).current;

    const debouncedColumnWidth = useRef(
      _.debounce((columnId, newWidth, preferences) => {
        onColumnWidthChanged &&
          onColumnWidthChanged(columnId, newWidth, preferences);
      }, 500)
    ).current;

    const handleExportLeads = async () => {
      try {
        let payload: any = {};

        if (isFilterSelectionMode) {
          // Filter mode: Send complete filterParams (backend will handle pagination)
          payload.filterParams = filterParam;

          logger.log('📤 Export with filterParams:', {
            filterParams: filterParam,
            totalAffected: leadCount
          });
        } else {
          // Manual mode: Send leadIds (existing behavior)
          payload.leadIds = getSelectedLeadIds();

          logger.log('📤 Export with manual selection:', {
            selectedCount: payload.leadIds.length
          });
        }

        await LeadExportService.exportBulkLeads(payload);

        // Exit filter mode after successful export
        if (isFilterSelectionMode) {
          setIsFilterSelectionMode(false);
        }
      } catch (error) {
        logger.error('❌ Export operation failed:', error);
        toast.error('Failed to export leads. Please try again.');
      }
    };

 
  const openDistributionChart = useCallback((field: string) => {
  logger.log('Opening distribution chart for field:', field);
  setDistributionField(field);
  setShowDistributionChart(true);
}, []);
    
    const closeDistributionChart = () => {
      setShowDistributionChart(false);
      setDistributionField('');
    };

    // Column filter handlers
    const handleColumnFilterApply = useCallback((colId: string, filterConfig: any) => {
      logger.log('📊 Column filter applied:', { colId, filterConfig });

      setColumnFilters(prev => {
        const updated = { ...prev };

        if (!filterConfig || !filterConfig.operator || !filterConfig.value) {
          delete updated[colId];
        } else {
          updated[colId] = filterConfig;
        }

        // Define standard field columns that have direct filter support
        const standardFieldMap: Record<string, string> = {
          'name': 'search',        // Name filtering uses the search parameter
          'phone': 'search',       // Phone can also use search
          'email': 'search',       // Email uses search
          'leadId': 'search',      // Lead ID uses search
          'createdBy': 'search',   // Created by uses search
          'assignedTo': 'search',  // Assigned to uses search
          'lastActivityLabel': 'search', // Last activity uses search
          'integration': 'source', // Source uses source parameter (array of IDs)
          'status': 'status',      // Status uses status parameter (array)
          'label': 'label',        // Label uses label parameter (array)
          'createdAt': 'date',     // ✅ Created At uses date parameter {startedAt, endedAt}
          'saleValue': 'customFieldFilter', // Sale value is a custom field
        };

        let mergedFilter = { ...filterParam };

        if (!filterConfig) {
          // Clear the filter
          if (standardFieldMap[colId] === 'search') {
            delete mergedFilter.search;
          } else if (standardFieldMap[colId] === 'source') {
            delete mergedFilter.source; // ✅ Clear source filter
          } else if (standardFieldMap[colId] === 'date') {
            delete mergedFilter.date; // ✅ Clear date filter
          } else if (standardFieldMap[colId] === 'customFieldFilter') {
            delete mergedFilter.customFieldFilter;
          }
          // For other standard fields, we'd need specific handling
        } else {
          // Apply the filter
          if (standardFieldMap[colId] === 'search') {
            // For name, phone, email, leadId, etc. - use search parameter
            mergedFilter.search = filterConfig.value;
            logger.log('✅ Using search parameter for:', colId, filterConfig.value);
          } else if (standardFieldMap[colId] === 'source') {
            // ✅ Source filtering uses source parameter with array of integration IDs
            // filterConfig.value contains the display value (e.g., "CSV")
            // We need to map it to integrationId using the same logic as leadFilter
            const hardcodedSourceMap: { [key: string]: string } = {
              'CSV': '64109561e6c7e737227a637c',
              'Lead Form': '64109561e6c7e737227a6382',
              'Google spread sheets': '65ccd9a61a0a18534633c277'
            };

            // If it's a hardcoded source, use the mapped ID; otherwise use the value directly (it's already an ID)
            const integrationId = hardcodedSourceMap[filterConfig.value] || filterConfig.value;
            mergedFilter.source = [integrationId]; // Wrap in array as backend expects array
            logger.log('✅ Using source parameter:', { displayValue: filterConfig.value, integrationId, array: mergedFilter.source });
          } else if (standardFieldMap[colId] === 'date') {
            // ✅ Date filtering uses date parameter with {startedAt, endedAt}
            if (filterConfig.operator.value === 'between') {
              mergedFilter.date = {
                startedAt: filterConfig.value,
                endedAt: filterConfig.endValue
              };
            } else if (filterConfig.operator.value === 'eq') {
              // "is" - same day start to end
              const dayStart = moment(filterConfig.value).startOf('day').format();
              const dayEnd = moment(filterConfig.value).endOf('day').format();
              mergedFilter.date = {
                startedAt: dayStart,
                endedAt: dayEnd
              };
            } else if (filterConfig.operator.value === 'lt') {
              // "is before" - from epoch to selected date
              mergedFilter.date = {
                startedAt: '1970-01-01',
                endedAt: filterConfig.value
              };
            } else if (filterConfig.operator.value === 'gt') {
              // "is after" - from selected date to future
              mergedFilter.date = {
                startedAt: filterConfig.value,
                endedAt: moment().add(10, 'years').format() // Far future date
              };
            }
            logger.log('✅ Using date parameter:', mergedFilter.date);
          } else {
            // For custom fields and saleValue - use customFieldFilter
            logger.log('🔧 Building customFieldFilter for:', colId);

            mergedFilter.customFieldFilter = {
              fieldName: colId,
              ...(filterConfig.operator.value === 'between' ? {
                range: {
                  start: { operator: 'gte', value: filterConfig.value },
                  end: { operator: 'lte', value: filterConfig.endValue || filterConfig.value }
                }
              } : {
                single: {
                  operator: filterConfig.operator.value,
                  // Handle array values for multi-selection "contain" operator
                  value: Array.isArray(filterConfig.value)
                    ? filterConfig.value
                    : filterConfig.value
                }
              })
            };

            logger.log('✅ Created customFieldFilter:', mergedFilter.customFieldFilter);
          }
        }

        // Add pagination reset
        mergedFilter.paginationParams = { page: 1, perPage: 50 };

        logger.log('📤 Dispatching column filter:', JSON.stringify(mergedFilter, null, 2));
        dispatch(setLeadFilter(mergedFilter));

        return updated;
      });
    }, [filterParam, dispatch]);

    const handleColumnSort = useCallback((colId: string, direction: 'asc' | 'desc') => {
      logger.log('📊 Column sort applied:', { colId, direction });

      setColumnSort({ colId, direction });

      // Map column IDs to backend sort field names
      const sortFieldMap: Record<string, string> = {
        'leadId': 'leadId',
        'name': 'name',
        'phone': 'phone',
        'email': 'email',
        'integration': 'integration',
        'status': 'status',
        'label': 'label',
        'createdAt': 'createdDate', // Backend uses 'createdDate' not 'createdAt'
        'createdBy': 'createdBy',
        'lastActivityLabel': 'activityDate', // Backend uses 'activityDate' for last activity
        'assignedTo': 'assignedTo',
        'saleValue': 'saleValue',
        'campaign_name': 'campaign_name',
        'formName': 'formName',
      };

      // Get the backend field name, fallback to colId if not mapped
      const backendField = sortFieldMap[colId] || colId;

      logger.log('📊 Sort mapping:', {
        frontendColumn: colId,
        backendField,
        direction,
        isAscending: direction === 'asc'
      });

      const mergedFilter = {
        ...filterParam,
        sort: {
          orderBy: backendField,
          isAscending: direction === 'asc'
        },
        paginationParams: { page: 1, perPage: 50 }
      };

      logger.log('📤 BEFORE dispatch - mergedFilter:', JSON.stringify(mergedFilter, null, 2));
      logger.log('📤 BEFORE dispatch - mergedFilter.sort:', mergedFilter.sort);

      // ✅ FIX: Dispatch to Redux - the useEffect in leads.tsx will handle the fetch
      // with a setTimeout(0) to avoid race condition
      dispatch(setLeadFilter(mergedFilter));

      // Log what's in Redux after dispatch (for debugging)
      setTimeout(() => {
        const currentState = store.getState();
        const currentFilterParam = currentState.rootReducers.leads.filterParam;
        logger.log('📥 AFTER dispatch - Redux filterParam:', JSON.stringify(currentFilterParam, null, 2));
        logger.log('📥 AFTER dispatch - Redux sort:', currentFilterParam.sort);
      }, 50);
    }, [filterParam, dispatch]);

   // Replace the handleStatusUpdate function with this improved version
const handleStatusUpdate = (updatedData: any) => {
  Logger.log('🎯 Status update completed:', updatedData);
  
  // Handle both single object and array cases
  const updatedRows = Array.isArray(updatedData) ? updatedData : [updatedData];
  
  Logger.log('🎯 Converted to array:', updatedRows);
  
  if (updatedRows && updatedRows.length > 0) {
    // Use the shared refresh function for consistency
    refreshCurrentPageInGridFn(updatedRows);
  }
  
  // Reset state
  setShowStatusPopup(false);
  setStatusEditLead(null);
  setSelectedStatus("");
};
    
    // Add this to handle status popup closing
    const toggleStatusPopup = () => {
      setShowStatusPopup(false);
      setStatusEditLead(null);
      setSelectedStatus("");
    };
  

    const handleLabelUpdate = (updatedData: any) => {
      Logger.log('🏷️ Label update completed:', updatedData);
      
      // Handle both single object and array cases
      const updatedRows = Array.isArray(updatedData) ? updatedData : [updatedData];
      
      Logger.log('🏷️ Converted to array:', updatedRows);
      
      if (updatedRows && updatedRows.length > 0) {
        // Use the shared refresh function for consistency
        refreshCurrentPageInGridFn(updatedRows);
      }
      
      // Reset state
      setShowLabelPopup(false);
      setLabelEditLead(null);
      setSelectedLabel([]);
    };
    
    // Add this to handle label popup closing
    const toggleLabelPopup = () => {
      setShowLabelPopup(false);
      setLabelEditLead(null);
      setSelectedLabel([]);
    };

    // Inside the LeadsGrid component, add this function
const applyChartHeaders = useCallback((columns: ColDef[]) => {
  return columns.map(column => {
    // Cast to access the hasDistributionChart property
    const colDef = column as unknown as BaseColumnDefinition & ColDef;
    
    if (colDef.hasDistributionChart) {
      return {
        ...colDef,
        headerComponent: (params: any) => {
          return (
            <div className="flex items-center gap-2">
              <span>{colDef.headerName}</span>
              <ChartLine 
                className="cursor-pointer hover:text-blue-500"
                size={16}
                onClick={(e) => {
                  e.stopPropagation();
                  openDistributionChart(colDef.colId);
                }}
              />
            </div>
          );
        }
      };
    }
    
    return colDef;
  });
}, [openDistributionChart]);

    const fetchContentTemplates = async () => {
      try {
        Logger.log('Fetching content templates');
        // Use the existing getAllContent function with pagination
        const response = await getAllContent({
          page: 1,           // Starting page
          perPage: 500       // Number of items per page
        });
        
        if (response && response.status === 200) {
          setContentTemplates(response.data.data || []);
          Logger.log('Content templates fetched:', response.data.data?.length);
        }
      } catch (error) {
        console.error('Error fetching content templates:', error);
        toast.error('Failed to load content templates');
      }
    };
    
    // 4. Add function to handle bulk share action
    const handleBulkShare = async () => {
      Logger.log('Bulk share initiated');
      
      // Since we're in the grid component, we can access gridApi directly
      if (!gridApi || !gridApi.current) {
        toast.error('Unable to access lead grid');
        return;
      }
    
      // Get selected lead IDs directly
      const selectedNodes = gridApi.current.getSelectedNodes();
      if (!selectedNodes || selectedNodes.length === 0) {
        toast.error('Please select leads first');
        return;
      }
    
      // Fetch content templates if not already loaded
      if (contentTemplates.length === 0) {
        await fetchContentTemplates();
      }
    
      // Get lead data for the selected leads
      try {
        setIsLoading(true);
        
        // Extract the selected leads from the grid data
        const leadsData: any[] = [];
        
        selectedNodes.forEach((node: any) => {
          if (node.data) {
            leadsData.push({
              _id: node.data._id,
              name: node.data.name,
              phone: node.data.phone,
              email: node.data.email
            });
          }
        });
        
        setSelectedLeadsForShare(leadsData);
        setShowBulkShareModal(true);
      } catch (error) {
        console.error('Error preparing leads for bulk share:', error);
        toast.error('Failed to prepare leads for sharing');
      } finally {
        setIsLoading(false);
      }
    };

const sanitizeFilterParams = (params: FilterParams): FilterParams => {
  const sanitized = {...params};
  
  Object.keys(sanitized).forEach(key => {
      const value = sanitized[key];
      if (value === undefined || value === null || value === '') {
          delete sanitized[key];
      } else if (Array.isArray(value) && value.length === 0) {
          delete sanitized[key];
      } else if (typeof value === 'object' && !Array.isArray(value) && 
                 Object.keys(value).length === 0) {
          delete sanitized[key];
      }
  });

  return sanitized;
};

    
   



   // Update the getCustomColumnDef function in leads-grid.tsx

const getCustomColumnDef = (form: any, columnWidths: any) => {
  let cellRenderer;
  if (form.type === "location") {
    cellRenderer = locationRenderer;
  } else if (form.type === "date") {
    cellRenderer = dateRenderer;
  } else if (form.type === "url") {
    cellRenderer = urlRenderer;
  } else if (form.type === "address") {
    cellRenderer = addressRenderer;
  } else if (form.value === "saleValue") {
    cellRenderer = saleValueRenderer;
  } else if (form.value === "campaign_name") {
    cellRenderer = campaignNameRenderer;
  } else if (form.value === "formName") {
    cellRenderer = formNameRenderer;
  }
  
  // If no specific renderer is set, use the editable custom field renderer for interactivity
  if (!cellRenderer) {
    cellRenderer = editableCustomFieldRenderer;
  }
  
  // Determine the correct field path
  let field;
  if (["saleValue", "email","note"].includes(form.value)) {
    field = form.value;
  } else if (["campaign_name", "formName"].includes(form.value)) {
    field = `extraDetails.${form.value}`;
  } else {
    field = `extraDetails.${form.value}`;
  }
  
  return {
    headerName: form.label,
    sortable: false,
    width: columnWidths[form.value] || 150,
    field: field,
    colId: form.value,
    cellRenderer,
  };
};

   

const fetchLeadListOnScroll = (
  params: IFetchRowsParams,
  leadName?: string, // Keep parameter for now to avoid breaking change
  search?: string
) => {

  // Get fresh state directly from Redux
  const currentState = store.getState().rootReducers;
  const currentReduxFilters = currentState.leads.filterParam;
  const currentLeadName = currentState.leadName.leadName;

  logger.log('🚀 fetchLeadListOnScroll called - FULL REDUX STATE:');
  logger.log('🚀 currentReduxFilters:', JSON.stringify(currentReduxFilters, null, 2));
  logger.log('🚀 currentReduxFilters.sort:', currentReduxFilters.sort);
  logger.log('🚀 typeof sort:', typeof currentReduxFilters.sort);
  logger.log('🚀 sort === undefined:', currentReduxFilters.sort === undefined);
  logger.log('🚀 Current lead name from Redux:', currentLeadName);
  logger.log('🚀 Parameter leadName (will be ignored):', leadName);
  logger.log('🚀 StoreData.leadName:', StoreData?.leadName?.leadName?.id);

  // Use the fresh state - PRESERVE SORT FROM REDUX!
  let updatedFilterParams = {
    ...currentReduxFilters,
    // DON'T override sort from params - use Redux sort which has our column header sort
    // sort: { orderBy: params.orderBy, isAscending: params.isAscending }, // ❌ This was overwriting our sort!
    paginationParams: { perPage: params.perPage, page: params.page },
  };

  logger.log('🎯 After spreading - updatedFilterParams:', JSON.stringify(updatedFilterParams, null, 2));
  logger.log('🎯 After spreading - updatedFilterParams.sort:', updatedFilterParams.sort);
  logger.log('🎯 Final filter params (list ID from Redux):', updatedFilterParams);
  
  
  
  // IMPORTANT: No second parameter - use list ID from Redux state only
  return fetchLeads(updatedFilterParams);
};

    const handleRowClick = (params: any) => {
      // Detailed debugging log
     
      
      // Check our flag - if any protected column was clicked, skip processing
      logger.log('🔍 Action column flag:', actionColumnClicked.current);
      if (actionColumnClicked.current) {
        logger.log(`🛑 Skipping row click - ${actionColumnClicked.current} column was clicked`);
        actionColumnClicked.current = ''; // Reset for next time
        
        return;
      }
      
      
    
      // Extract data with your existing approach  
      const rowData = 
        params?.data || 
        params?.node?.data || 
        (typeof params === 'object' && !Array.isArray(params) ? params : null);
      
      // Comprehensive logging
      Logger.log('Extracted Row Data:', rowData);
      
      // Robust data extraction and validation
      if (!rowData) {
        Logger.warn('No valid row data could be extracted', {
          originalParams: params,
          extractionAttempts: [
            params?.data,
            params?.node?.data,
            typeof params === 'object' ? params : null
          ]
        });
        return;
      }
      
      // Ensure handleLeadClick is a function before calling
      if (typeof handleLeadClick !== 'function') {
        console.error('handleLeadClick is not a valid function');
        return;
      }
      
      try {
        handleLeadClick(rowData);
      } catch (error) {
        console.error('Error in handleLeadClick:', error);
      }
    };

    const comparePreferencesAreEqual = (newPref: any, oldPref: any) => {
      return isEqual(newPref, oldPref);
    };

    
    const onColumnOrderChanged = (
      orders: string[],
      preferences: PreferenceI
    ) => {
      const uniqueOrders = [...new Set(orders)];
      const leadGridPreferences = {
        ...preferences.leadGridPreferences,
        columnOrders: uniqueOrders,
      };
      if (
        !comparePreferencesAreEqual(
          leadGridPreferences,
          preferences.leadGridPreferences
        )
      ) {
        dispatch(
          userPreferences({
            ...preferences,
            leadGridPreferences,
          })
        );
        handleAddGridPreferences(leadGridPreferences);
      }
    };

    const onColumnWidthChanged = (
      colId: string,
      newWidth: number,
      preferences: PreferenceI
    ) => {
      const updatedColumnWidths = {
        ...(preferences.leadGridPreferences?.columnWidths || {}),
        [colId]: newWidth,
      };

      const leadGridPreferences = {
        ...preferences.leadGridPreferences,
        columnWidths: updatedColumnWidths,
      };

      if (
        !comparePreferencesAreEqual(
          leadGridPreferences,
          preferences.leadGridPreferences
        )
      ) {
        dispatch(
          userPreferences({
            ...preferences,
            leadGridPreferences,
          })
        );
        handleAddGridPreferences(leadGridPreferences);
      }
    };

    const handleAddGridPreferences = async (data: any) => {
      try {
        const response = await putUserPreferences({
          leadGridPreferences: data,
        });
        if (response && response.status) {
        }
      } catch (err: any) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Error while updating Source!");
        }
      }
    };

    const handleLabelClick = (data: any) => {
      if (!data || !data._id) {
        Logger.warn('No valid data for label click');
        return;
      }
      
      Logger.log('Label cell clicked with data:', data?._id);
      
      // Set the lead data for label update
      setLabelEditLead(data);
      setSelectedLabel(data?.label || []);
      
      // Trigger the onEditLabel callback
      onEditLabel(data);
    }

    const fetchLeadsWrapper = async () => {
      if (gridApi.current) {
        // Clear visible rows (doesn't purge cache)
        gridApi.current.setRowData([]);
        
        // Request refresh of infinite cache
        gridApi.current.refreshInfiniteCache();
        
        logger.log('Grid refreshed using setRowData + refreshInfiniteCache');
      }
    };

    
   

    
   // In LeadsGrid.tsx
// ENSURE fetchLeads in leads-grid.tsx is passing ALL parameters:
const fetchLeads = async (filterParam: FilterParams, leadName?: string) => {
  // Keep leadName parameter but don't use it
  
  
  logger.log('Incoming filter params:', filterParam);
  logger.log('leadName parameter (will be ignored):', leadName);
  
  try {
    setIsLoading(true);
    
    // Create the request object - DON'T override the list ID
    const requestParams = {
      ...filterParam, // Use filter params directly - list ID is already included
    };

    logger.log('Final API request (using list from Redux):', requestParams);
    logger.log('🔍 REQUEST PARAMS SORT:', requestParams.sort);
    logger.log('🔍 REQUEST PARAMS FULL:', JSON.stringify(requestParams, null, 2));

    const response = await filterLeads(requestParams);

    Logger.log('API Response:', {
      status: response?.status,
      totalRows: response?.data?.total,
      dataLength: response?.data?.data?.length,
      usedListId: requestParams.list // Log which list ID was actually used
    });

    if (response?.status === 200) {
      let responseData = response.data;
      dispatch(setLeadCount(responseData.total));
      return { 
        data: responseData.data, 
        totalRows: responseData.total 
      };
    }

  } catch (err) {
    console.error('❌ Fetch error:', err);
  } finally {
    setIsLoading(false);
    
  }
};
    

const getColunmmnDefs = () => {
  Logger.log('getColunmmnDefs returning:', 
    columnDefs.map(c => `${c.headerName} (${c.colId})`).join(', ')
  );
  return columnDefs;
};

  
const refreshCurrentPageInGridFn = (updatedRows: any[]) => {
  if (!gridApi.current) {
    logger.error('❌ Grid API not available for refresh');
    return;
  }
  
  if (!updatedRows || updatedRows.length === 0) {
    logger.warn('⚠️ No updated rows provided for refresh');
    return;
  }
  
  logger.log('🔄 Starting grid refresh for updated rows:', {
    count: updatedRows.length,
    leadIds: updatedRows.map(r => r._id),
    hasInfiniteCache: typeof gridApi.current.refreshInfiniteCache === 'function'
  });
  
  // Method 1: Try to update visible nodes first (for immediate feedback)
  let nodesUpdated = 0;
  updatedRows.forEach(updatedRow => {
    gridApi.current?.forEachNode(node => {
      if (node.data && node.data._id === updatedRow._id) {
        logger.log(`📝 Updating visible node: ${updatedRow._id}`, {
          oldStatus: node.data.status,
          newStatus: updatedRow.status
        });
        
        const mergedData = {
          ...node.data,
          ...updatedRow
        };
        
        node.setData(mergedData);
        nodesUpdated++;
      }
    });
  });
  
  logger.log(`✅ Updated ${nodesUpdated} visible nodes out of ${updatedRows.length} total updates`);
  
  // Method 2: CRITICAL - Invalidate infinite cache to force refresh from server
  if (gridApi.current.refreshInfiniteCache) {
    logger.log('🚀 Invalidating infinite cache to ensure server sync');
    gridApi.current.refreshInfiniteCache();
  } else {
    logger.warn('⚠️ refreshInfiniteCache method not available');
  }
  
  // Method 3: If no visible nodes were updated, do a full refresh
  if (nodesUpdated === 0) {
    logger.log('⚠️ No visible nodes updated, forcing full cache refresh');
    // Clear the cache and force a re-fetch
    gridApi.current.setRowData([]);
    setTimeout(() => {
      if (gridApi.current?.refreshInfiniteCache) {
        gridApi.current.refreshInfiniteCache();
      }
    }, 100);
  } else {
    // Refresh visible cells for immediate feedback
    gridApi.current?.redrawRows();
    logger.log('🎨 Redraw completed for immediate visual update');
  }
  
  logger.log('✅ Grid refresh complete');
};
    
    const resetGridState = useCallback(() => {
      if (!gridApi.current) return;
      
      // Clear selection
      gridApi.current.deselectAll();
      
      // Reset data
      gridApi.current.setRowData([]);
      
      // Force refresh
      setResetGrid(prev => prev + 1);
    }, []);

// In leads-grid.tsx, complete onGridReady function
const onGridReady = (params: any) => {
 
  Logger.log('Grid initialization:', {
    hasApi: !!params.api,
    rowCount: params.api?.getDisplayedRowCount(),
    currentFilter: filterParam
  });
  
  // Keep existing event listener for distribution chart
  params.api.addEventListener('openDistributionChart', (event: any) => {
    openDistributionChart(event.field);
  });
  
  gridApi.current = params.api;

  // Add manual page input feature
  const setupManualPageInput = () => {
    setTimeout(() => {
      const pagingDescription = document.querySelector('.ag-paging-description');
      if (!pagingDescription) return;

      const pageText = pagingDescription.textContent || '';
      const match = pageText.match(/Page\s+(\d+)\s+of\s+(\d+)/);

      if (match) {
        const currentPage = match[1];
        const totalPages = match[2];

        pagingDescription.innerHTML = `
          Page <span class="page-number-editable" id="current-page-number">${currentPage}</span> of ${totalPages}
        `;

        const pageNumberSpan = document.getElementById('current-page-number');
        if (pageNumberSpan) {
          pageNumberSpan.addEventListener('click', () => {
            const input = document.createElement('input');
            input.type = 'text';
            input.className = 'page-number-input';
            input.value = currentPage;
            input.maxLength = totalPages.length;
            input.style.width = `${Math.max(40, totalPages.length * 12 + 20)}px`;

            pageNumberSpan.replaceWith(input);
            input.focus();
            input.select();

            const goToPage = () => {
              const pageNum = parseInt(input.value);
              const total = parseInt(totalPages);

              if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= total) {
                params.api.paginationGoToPage(pageNum - 1);
              } else {
                alert(`Please enter a page number between 1 and ${total}`);
              }

              setTimeout(setupManualPageInput, 100);
            };

            input.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') {
                goToPage();
              } else if (e.key === 'Escape') {
                setTimeout(setupManualPageInput, 100);
              }
            });

            input.addEventListener('blur', goToPage);
          });
        }
      }
    }, 500);
  };

  setupManualPageInput();
  params.api.addEventListener('paginationChanged', setupManualPageInput);

  // Updated cell clicked handler with improved status and label handling

// Updated cell clicked handler with improved status and label handling
params.api.addEventListener('cellClicked', (event: any) => {
  logger.log('📍 Cell clicked debug:', {
    colId: event.column.colId,
    data: event.data?._id,
    easySelectMode: easySelectModeRef.current
  });
  
  // NEW: Handle easy select mode for ALL columns
  if (easySelectModeRef.current && event.data) {
    logger.log('🎯 Easy select mode: Selecting row and preventing drawer');
    event.node.setSelected(!event.node.isSelected()); // Toggle selection
    actionColumnClicked.current = 'easySelect'; // Prevent drawer from opening
    return; // Exit early - don't process any other column logic
  }
  
  // Handle status cell click
  if (event.column.colId === 'status') {
    actionColumnClicked.current = 'status';
    event.node.setSelected(false);
    
    // Extract data properly - try multiple methods
    const leadData = event.data || event.node?.data || event;
    
    logger.log('📊 Status cell clicked with data:', {
      hasEventData: !!event.data,
      hasNodeData: !!event.node?.data,
      hasEvent: !!event,
      leadId: leadData?._id,
      status: leadData?.status
    });
    
    if (leadData && leadData._id) {
      // Set the lead data for status update
      setStatusEditLead(leadData);
      setSelectedStatus(leadData.status?.[0] || "");
      
      // Trigger the status popup
      setShowStatusPopup(true);
    } else {
      logger.error('❌ No valid lead data found for status update');
    }
  }
  // Handle label cell click
  else if (event.column.colId === 'label') {
    actionColumnClicked.current = 'label';
    event.node.setSelected(false);
    
    // Extract data properly - try multiple methods
    const leadData = event.data || event.node?.data || event;
    
    logger.log('📋 Label cell clicked with data:', {
      hasEventData: !!event.data,
      hasNodeData: !!event.node?.data,
      hasEvent: !!event,
      leadId: leadData?._id,
      labels: leadData?.label
    });
    
    if (leadData && leadData._id) {
      // Set the lead data for label update
      setLabelEditLead(leadData);
      setSelectedLabel(leadData.label || []);
      
      // Trigger the onEditLabel callback with the FULL DATA
      if (typeof onEditLabel === 'function') {
        logger.log('📤 Sending lead data to parent with ID:', leadData._id);
        onEditLabel(leadData);
      }
    } else {
      logger.error('❌ No valid lead data found for label update');
    }
  }
  // Handle sale value cell click
  else if (event.column.colId === 'saleValue' && event.data) {
    actionColumnClicked.current = 'saleValue';
    event.node.setSelected(false);
    
    // Open product picker for this lead
    if (gridContext.openProductPicker) {
      gridContext.openProductPicker(event.data);
    }
  }
  // Handle assignedTo cell click - NEW CODE
  else if (event.column.colId === 'assignedTo' && event.data) {
    actionColumnClicked.current = 'assignedTo';
    event.node.setSelected(false);

    // Call the handler from gridContext
    if (gridContext && typeof gridContext.onAssignedToClick === 'function') {
      logger.log('Opening assign drawer for:', event.data.name);
      gridContext.onAssignedToClick(event.data);
    } else {
      console.warn('Missing handler for assignedTo', {
        hasGridContext: !!gridContext,
        hasFunction: !!gridContext?.onAssignedToClick
      });
    }
  }
  // NEW: Handle custom field cell clicks (editable fields)
  else if (event.data && gridContext.customFields?.some((field: any) => field.value === event.column.colId && !field.read_only)) {
    logger.log('🔧 Custom editable field clicked:', event.column.colId);
    actionColumnClicked.current = 'customField';
    event.node.setSelected(false);
    
    // Get field info
    const field = gridContext.customFields.find((f: any) => f.value === event.column.colId);
    
    if (field) {
      // Get the current value
      let currentValue = '';
      if (['email', 'phone', 'name', 'saleValue', 'notes'].includes(event.column.colId)) {
        currentValue = event.data[event.column.colId] || '';
      } else {
        currentValue = event.data.extraDetails?.[event.column.colId] || '';
      }
      
      // Get the target cell element for positioning - use the actual clicked cell
      let targetElement = null;
      
      // Try to get the cell element from the grid event
      if (event.event && event.event.target) {
        // Find the cell element by traversing up the DOM tree
        let element = event.event.target as HTMLElement;
        while (element && element !== document.body && !element.hasAttribute('col-id')) {
          element = element.parentElement as HTMLElement;
        }
        if (element && element.hasAttribute('col-id') && element.getAttribute('col-id') === event.column.colId) {
          targetElement = element;
        }
      }
      
      // Fallback: Find cell by row index and column id
      if (!targetElement) {
        const rowNode = event.api.getRowNode(event.data._id);
        if (rowNode && rowNode.rowIndex !== null) {
          const cellElements = document.querySelectorAll(`[col-id="${event.column.colId}"][row-index="${rowNode.rowIndex}"]`);
          if (cellElements.length > 0) {
            targetElement = cellElements[0] as HTMLElement;
          }
        }
      }
      
      // Final fallback: any cell with the column id
      if (!targetElement) {
        const cellElements = document.querySelectorAll(`[col-id="${event.column.colId}"]`);
        if (cellElements.length > 0) {
          targetElement = cellElements[0] as HTMLElement;
        }
      }
      
      // Calculate position immediately before opening
      let calculatedPosition = { top: 0, left: 0, width: 200, height: 32 };
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        
        calculatedPosition = {
          top: rect.top + scrollY,
          left: rect.left + scrollX,
          width: rect.width,
          height: rect.height
        };
      } else {
        // If no target element found, log for debugging but don't break
        console.warn('InlineEditor: Target element not found for column:', event.column.colId);
      }

      // Open the inline editor with pre-calculated position
      setInlineEditorData({
        leadId: event.data._id,
        fieldConfig: field,
        currentValue: currentValue,
        targetElement: targetElement,
        position: calculatedPosition
      });
      setInlineEditorOpen(true);
    }
  }
});
  
};

    // Fix the column mapping in the useEffect in leads-grid.tsx

    const handleCellValueChange = useCallback(async (leadId: string, fieldName: string, newValue: any): Promise<boolean> => {
      try {
        logger.log(`Updating cell value for lead ${leadId}, field: ${fieldName}, value:`, newValue);
        
        // Show loading toast
        const loadingToast = toast.loading("Updating...");
        
        // Get current lead data to preserve existing extraDetails
        let currentLead: any = null;
        if (gridApi.current) {
          gridApi.current.forEachNode(node => {
            if (node.data && node.data._id === leadId) {
              currentLead = node.data;
            }
          });
        }
        
        // Prepare the update payload
        const updatePayload: any = {};
        
        // For standard fields like email, phone, name, saleValue
        if (['email', 'phone', 'name', 'saleValue', 'notes'].includes(fieldName)) {
          updatePayload[fieldName] = newValue;
        } else {
          // For custom fields, preserve existing extraDetails and update only the specific field
          updatePayload.extraDetails = {
            ...(currentLead?.extraDetails || {}), // Preserve existing extraDetails
            [fieldName]: newValue // Update only the specific field
          };
        }
        
        // Call the update API
        const response = await updateLead(leadId, updatePayload);
        
        toast.dismiss(loadingToast);
        
        if (response && response.status === 200) {
          toast.success("Field updated successfully");
          
          // Update the grid data
          if (gridApi.current) {
            // Find the row and update it
            gridApi.current.forEachNode(node => {
              if (node.data && node.data._id === leadId) {
                const updatedData = { ...node.data };
                
                if (['email', 'phone', 'name', 'saleValue', 'notes'].includes(fieldName)) {
                  updatedData[fieldName] = newValue;
                } else {
                  if (!updatedData.extraDetails) {
                    updatedData.extraDetails = {};
                  }
                  updatedData.extraDetails[fieldName] = newValue;
                }
                
                node.setData(updatedData);
                
                // Update Redux store as well
                dispatch(updateSingleLead(updatedData));
              }
            });
            
            // Refresh the grid to show changes
            gridApi.current.refreshCells({ force: true });
          }
          
          return true;
        } else {
          toast.error("Failed to update field");
          return false;
        }
        
      } catch (error: any) {
        console.error("Error updating cell value:", error);
        toast.error(error?.response?.data?.message || "Failed to update field");
        return false;
      }
    }, [dispatch, gridApi]);

    const handleProductsSelect = useCallback((products: ProductWithQuantity[]) => {
      if (!selectedLeadForProducts?._id) {
        console.error("No lead selected for product update");
        return;
      }
      
      logger.log("Products selected:", products.length);
      
   
     // Calculate total value - use manual override if provided
const calculatedTotal = (products as any).manualSaleValue || products.reduce(
  (sum, p) => sum + (p.price * p.quantity), 
  0
);

logger.log("Using total value:", {
  manualOverride: (products as any).manualSaleValue,
  calculated: products.reduce((sum, p) => sum + (p.price * p.quantity), 0),
  finalUsed: calculatedTotal
});
      
      // Format products for API
      const productsForApi = products.map(p => ({
        id: p._id,
        quantity: p.quantity
      }));
      
      // Show loading toast
      const loadingToast = toast.loading("Updating lead...");
      
      // Call API to update products
      updateLeadProducts(
        selectedLeadForProducts._id,
        productsForApi,
        calculatedTotal
      )
        .then(response => {
          toast.dismiss(loadingToast);
          toast.success("Products updated successfully");
          
          logger.log("API response:", response?.data?.data);
          
          if (response?.data?.data) {
            const updatedLead = response.data.data;
            
            // Update the grid with the new data
            if (gridApi.current) {
              logger.log("Refreshing grid with updated lead");
              refreshCurrentPageInGridFn([updatedLead]);
            }
          }
        })
        .catch(error => {
          console.error("Product update error:", error);
          toast.dismiss(loadingToast);
          toast.error("Failed to update products");
        })
        .finally(() => {
          setProductPickerOpen(false);
          setSelectedLeadForProducts(null);
        });
    }, [selectedLeadForProducts, refreshCurrentPageInGridFn]);

    const gridContext = useMemo(() => ({
      openProductPicker: (leadData: any) => {
        logger.log("Opening product picker for:", leadData?.name);
        setSelectedLeadForProducts(leadData);
        
        // Initialize selected products from lead data
        if (leadData.products?.length > 0) {
          logger.log("Lead has existing products:", leadData.products.length);
          setSelectedProducts(leadData.products);
        } else {
          logger.log("No existing products for this lead");
          setSelectedProducts([]);
        }
        
        setProductPickerOpen(true);
      },
      onAssignedToClick: (leadData: any) => {
        logger.log("Opening assign drawer for lead:", leadData?.name);
        // Set the lead ID for assignment
        setSelectedLeadsForAssign([leadData._id]);
        // Open the assignment drawer
        setShowAssignDrawer(true);
      },
      onCellValueChange: handleCellValueChange,
      customFields: preferences?.customForm || [],
      setActionColumnClicked: (actionType: string) => {
        actionColumnClicked.current = actionType;
      },
      triggerCellEdit: (leadId: string, fieldId: string) => {
        logger.log('🔧 Triggering cell edit for:', { leadId, fieldId });
        setEditTrigger({ leadId, fieldId });
        // Clear the trigger after a longer delay to ensure cells receive it
        setTimeout(() => {
          logger.log('🔧 Clearing edit trigger');
          setEditTrigger(null);
        }, 500);
      },
      editTrigger
    }), [handleCellValueChange, preferences?.customForm, editTrigger]);

    
    useEffect(() => {
 
  logger.log('Effect triggered with dependencies:');
  logger.log('- preferences available:', !!preferences);
  logger.log('- onEditLabel available:', !!onEditLabel);
  
  if (!preferences) {
    logger.log('⚠️ No preferences available, skipping column processing');
    
    return;
  }
  
  logger.log('⏱️ Render timestamp:', new Date().toISOString());
  logger.log('👉 Processing columns at', performance.now().toFixed(2));
  
  preferenceRef.current = preferences;
  const userSelectedColumns = preferences.leadGridPreferences?.columnOrders || [];
  const columnWidths = preferences.leadGridPreferences?.columnWidths || {};

  logger.log('Column processing started:', {
    userSelectedCount: userSelectedColumns.length,
    userSelected: userSelectedColumns,
    widthsAvailable: Object.keys(columnWidths).length,
    hasStatusInPreferences: !!preferences.status,
    statusCount: preferences.status?.length || 0
  });
  
  // Define essential columns that should always be present
// ✅ ENHANCED - Handle missing essential columns gracefully:
logger.log('User selected columns:', userSelectedColumns);

let completeColumnList;

if (userSelectedColumns.length === 0) {
  // No preferences - use defaults
  completeColumnList = getDefaultColumnOrder();
  logger.log('No preferences - using defaults:', completeColumnList);
} else {
  // Check if essential columns are missing (backward compatibility)
  const essentialColumns = ['name', 'phone']; // Minimum required for functionality
  const missingEssentials = essentialColumns.filter(col => !userSelectedColumns.includes(col));
  
  if (missingEssentials.length > 0) {
    logger.log('Missing essential columns, adding them:', missingEssentials);
    completeColumnList = [
      ...missingEssentials,  // Add missing essentials at the start
      ...userSelectedColumns
    ];
  } else {
    // Use exactly what user selected (complete grid state)
    completeColumnList = userSelectedColumns;
  }
}

logger.log('Final column list (with essentials):', completeColumnList);
  
  logger.log('Complete column list (essential + user selected):', completeColumnList);
  
  // Process all columns to create column definitions
  let processingTime = performance.now();
  const processedColumns = completeColumnList
    .map(colId => {
      // Try to get from registry first
      if (ColumnRegistry[colId]) {
        const regCol = ColumnRegistry[colId];
        logger.log(`Processing column ${colId}:`, {
          headerName: regCol.headerName,
          renderer: regCol.cellRenderer?.name || 'undefined',
          value: regCol.field
        });
        
        // Create a copy of the column definition
        const columnDef = {
          headerName: regCol.headerName,
          field: regCol.field,
          colId: regCol.colId,
          width: columnWidths[colId] || regCol.width || 150,
          sortable: regCol.sortable !== undefined ? regCol.sortable : false,
          cellRenderer: regCol.cellRenderer,
          suppressNavigable: regCol.suppressNavigable,
          headerCheckboxSelection: colId === 'name',
          checkboxSelection: colId === 'name'
        };
        
        // For status and label columns, add the preferences to cellRendererParams
        if (colId === 'status') {
          logger.log(`Adding preferences to status column:`, {
            hasPreferences: !!preferences,
            statusCount: preferences.status?.length || 0
          });
          
          // Replace the cellRenderer with a wrapper function that includes preferences
          columnDef.cellRenderer = (params: any) => {
            return statusRenderer({ 
              ...params, 
              preferences, 
              onStatusClick: (data: any) => {
                setStatusEditLead(data);
                setSelectedStatus(data?.status?.[0] || "");
                setShowStatusPopup(true);
              }
            });
          };
        } 
        else if (colId === 'label') {
          logger.log(`Adding preferences to label column:`, {
            hasPreferences: !!preferences,
            labelsCount: preferences.labels?.length || 0
          });
          
          // Replace the cellRenderer with a wrapper function that includes preferences
          columnDef.cellRenderer = (params: any) => {
            return labelRenderer({ 
              ...params, 
              preferences,
              onLabelClick: (data: any) => {
                setLabelEditLead(data);
                setSelectedLabel(data?.label || []);
                onEditLabel(data);
              }
            });
          };
        }
        
        return columnDef;
      } 
      // Check if it's a custom field
      else if (preferences.customForm?.length) {
        const customField = preferences.customForm.find(f => f.value === colId);
        if (customField) {
          logger.log(`Processing custom field: ${colId} (${customField.label})`);
          return createCustomFieldColumnDef(customField, columnWidths);
        }
      }
      
      logger.log(`Column not found in registry or custom fields: ${colId}`);
      return null;
    })
    .filter(Boolean) as ColDef[];
  
  // Ensure we have at least name and phone if somehow everything is empty
  if (processedColumns.length === 0) {
    console.warn('No columns processed, falling back to defaults');
    const fallbackColumns = ['name', 'phone'].map(colId => {
      const col = ColumnRegistry[colId];
      return {
        ...col,
        width: columnWidths[colId] || col.width || 150,
        headerCheckboxSelection: colId === 'name',
        checkboxSelection: colId === 'name'
      };
    });
    processedColumns.push(...fallbackColumns);
  }
  
  // Add listName column when searching across all lists
  if (filterParam?.isIgnoreList === true) {
    const listNameColumn = {
      headerName: 'List name',
      field: 'listName',
      colId: 'listName',
      width: 200,
      sortable: false,
      cellRenderer: (params: any) => {
        const listName = params.value || 'Unknown';
        return (
        <span style={{ 
            fontSize: '15px', 
            fontWeight: '500',
            color: '#495057', 
            backgroundColor: '#e9ecef', 
            border: '1px solid #dee2e6',
            padding: '4px 8px', 
            borderRadius: '4px',
            display: 'inline-block',
            maxWidth: '160px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={listName}
          >
            📋 {listName}
          </span>
        );
      }
    };
    processedColumns.push(listNameColumn);
  }
  
  // ADD CHART HEADERS AND COLUMN FILTERS
  processedColumns.forEach(col => {
    const regDef = ColumnRegistry[col.colId as string];

    // For custom fields, check the column definition directly
    const colDef = col as unknown as BaseColumnDefinition & ColDef;
    const allowColumnFilter = colDef.allowColumnFilter || regDef?.allowColumnFilter || false;

    if (allowColumnFilter) {
      // Add column filter dropdown to header
      col.headerComponent = (params: any) => {
        // Use column-specific filter configuration
        let filterType = colDef.columnFilterType || regDef?.columnFilterType || 'text';
        let filterOptions = colDef.columnFilterOptions || regDef?.columnFilterOptions || [];

        // ✅ Special handling for source column - get from localStorage like leadFilter does
        if (col.colId === 'integration') {
          try {
            const userPreferences = JSON.parse(localStorage.getItem("user_preferences") || "{}");
            const userData = JSON.parse(localStorage.getItem("userData") || "{}");

            const allSources: any[] = [];

            // 1. Hardcoded sources (with integrationId for API)
            const hardcodedSources = [
              { value: 'CSV', label: 'CSV', integrationId: '64109561e6c7e737227a637c' },
              { value: 'Lead Form', label: 'Lead Form', integrationId: '64109561e6c7e737227a6382' },
              { value: 'Google spread sheets', label: 'Google Sheets', integrationId: '65ccd9a61a0a18534633c277' }
            ];
            allSources.push(...hardcodedSources);

            // 2. Custom sources from userPreferences
            const customSources = userPreferences?.customSource || [];
            customSources.forEach((source: any) => {
              if (source && source.name) {
                allSources.push({
                  value: source.value || source._id,
                  label: source.name,
                  integrationId: source.integrationId || source.value || source._id
                });
              }
            });

            // 3. User integrations (active only)
            const userIntegrations = userData?.userIntegrations || [];
            userIntegrations
              .filter((ui: any) => ui.isActive && ui.integration)
              .forEach((ui: any) => {
                allSources.push({
                  value: ui.integration._id,
                  label: ui.integration.name,
                  integrationId: ui.integration._id
                });
              });

            // Remove duplicates by value
            const uniqueSources = allSources.filter((source, index, self) =>
              index === self.findIndex((s) => s.value === source.value)
            );

            filterOptions = uniqueSources;
            filterType = 'multi-selection'; // ✅ Changed to multi-selection to match LeadFilter behavior
          } catch (error) {
            console.error('Error loading sources:', error);
            filterOptions = [];
          }
        }

        return React.createElement(ColumnFilterDropdown, {
          colId: col.colId as string,
          headerName: col.headerName || '',
          fieldType: filterType,
          fieldOptions: filterOptions,
          currentFilter: columnFilters[col.colId as string],
          currentSort: columnSort && columnSort.colId === col.colId ? columnSort.direction : null,
          onFilterApply: handleColumnFilterApply,
          onSort: handleColumnSort,
          allowSort: true,
          allowFilter: true,
        });
      };
    } else if (regDef?.hasDistributionChart) {
      // Original chart header logic
      col.headerComponent = (params: any) => {
        return React.createElement(
          'div',
          {
            className: 'flex items-center gap-2',
            style: {
              width: '100%',
              maxWidth: '100%',
              overflow: 'hidden'
            }
          },
          React.createElement('span', {
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: '1 1 auto',
              minWidth: 0
            }
          }, col.headerName),
          React.createElement(ChartLine, {
            className: 'cursor-pointer hover:text-blue-500',
            size: 16,
            style: {
              flexShrink: 0
            },
            onClick: (e: any) => {
              e.stopPropagation();
              openDistributionChart(col.colId as string);
            }
          })
        );
      };
    }
  });
  
  logger.log(`Final column count: ${processedColumns.length}, Columns:`, 
    processedColumns.map(c => `${c.headerName} (${c.colId})`).join(', ')
  );
  
  // Add debug logging for status and label columns
  const statusColumn = processedColumns.find(c => c.colId === 'status');
  const labelColumn = processedColumns.find(c => c.colId === 'label');
  
  logger.log('Status column in final definitions:', {
    exists: !!statusColumn,
    hasCustomRenderer: typeof statusColumn?.cellRenderer === 'function'
  });
  
  logger.log('Label column in final definitions:', {
    exists: !!labelColumn,
    hasCustomRenderer: typeof labelColumn?.cellRenderer === 'function'
  });
  
  // Update the column definitions state
  logger.log('⏱️ Setting column definitions after', (performance.now() - processingTime).toFixed(2), 'ms');
  setColumnDefs(processedColumns);
  
  // Also update the grid directly if already initialized
  if (gridApi.current) {
    logger.log('Applying columns directly to grid API');
  
gridApi.current.setGridOption('columnDefs', processedColumns); // ✅ Modern API
  }
  
  logger.log('⏱️ Total column processing took', (performance.now() - processingTime).toFixed(2), 'ms');

}, [preferences, openDistributionChart, columnFilters, columnSort, handleColumnFilterApply, handleColumnSort]);

    // ✅ Function to clear all column filters
    const clearColumnFilters = useCallback(() => {
      setColumnFilters({});
      setColumnSort(null);
      logger.log('✅ Column filters and sort cleared');
    }, []);

    // ✅ Function to get current column filters
    const getColumnFilters = useCallback(() => {
      return columnFilters;
    }, [columnFilters]);

    // Expose fetchLeadListOnScroll function using useImperativeHandle
    useImperativeHandle(ref, () => ({
      fetchLeadsWrapper,
      refreshCurrentPageInGridFn,
      getColunmmnDefs,
      getSelectedLeadIds,
      handleSelection,
      handleUnSelect,
      resetGridState,
      clearColumnFilters, // ✅ NEW: Expose method to clear column filters
      getColumnFilters, // ✅ NEW: Expose method to get current column filters
      handleColumnFilterApply, // ✅ NEW: Expose method to apply/remove column filters
      isFilterSelectionMode, // NEW: Expose filter selection mode state
    }));

    const [action, setAction] = useState<string>("");
const easySelectModeRef = useRef(false);

    const [leadId, setLeadId] = useState<string>("");

    // Function to select the next set of items
    const selectNextItems = (
      startIndex: number,
      total: number,
      allNodes: any[]
    ) => {
      const endIndex = Math.min(startIndex + total, allNodes.length);

      // Select the next rows
      for (let i = startIndex; i <= endIndex; i++) {
        allNodes[i]?.setSelected(true);
      }

      // Scroll to the last selected row
      if (endIndex > startIndex) {
        gridApi?.current?.ensureIndexVisible(endIndex - 1, "bottom");
      }

      return endIndex;
    };

    function isNearby(num1: number, num2: number, tolerance = 3) {
      return Math.abs(num1 - num2) <= tolerance;
    }

    const handleSelection = (total: number) => {
      if (!gridApi?.current) return;

      // NEW: If in filter mode, exit it when selecting manually
      if (isFilterSelectionMode) {
        logger.log('🔄 Exiting filter mode - switching to manual selection');
        setIsFilterSelectionMode(false);
      }

      // const selectedNodes: any = gridApi.current.getSelectedNodes();

      let currentPageRows = gridApi.current.getRenderedNodes();

      let startIndex = 0;

      currentPageRows.forEach((node: any, i: number) => {
        if (node.selected) {
          startIndex = i;
        }
      });

      // Determine the starting index
      // const startIndex =
      //   selectedNodes.length > 0
      //     ? selectedNodes[selectedNodes.length - 1].rowIndex + 1
      //     : 0;

      startIndex = startIndex === -1 ? 0 : startIndex;

      let isAllSelected = gridApi.current
        .getRenderedNodes()
        .every((node: any) => node.selected);

      if (
        isAllSelected ||
        isNearby(startIndex, gridApi.current.getRenderedNodes()?.length)
      ) {
        gridApi.current.paginationGoToNextPage();

        // Retry selection after the next page loads
        setTimeout(() => {
          const newNodes: any = [];
          gridApi?.current
            ?.getRenderedNodes()
            .map((node) => newNodes.push(node));
          selectNextItems(0, total, newNodes); // Start from the beginning of the new page
        }, 500); // Adjust timeout based on page load time

        return;
      }

      // Get all rendered nodes
      const allNodes: any = [];
      gridApi.current.getRenderedNodes()?.map((node) => allNodes.push(node));

      // Select the next set of rows
      const endIndex = selectNextItems(startIndex, total, allNodes);

      // debugger;

      // If there are no more rows on the current page, navigate to the next page
      if (
        startIndex >= endIndex &&
        gridApi?.current?.paginationGoToNextPage
        //  ||
        // endIndex === gridApi.current.getRenderedNodes()?.length
      ) {
        gridApi.current.paginationGoToNextPage();

        // Retry selection after the next page loads
        setTimeout(() => {
          const newNodes: any = [];
          gridApi?.current
            ?.getRenderedNodes()
            .map((node) => newNodes.push(node));
          selectNextItems(0, total, newNodes); // Start from the beginning of the new page
        }, 500); // Adjust timeout based on page load time
      }
    };

    const handleUnSelect = () => {
      if (!gridApi?.current) return;

      gridApi?.current.forEachNode((node) => {
        node.setSelected(false);
      });

      gridApi?.current?.deselectAll();

      setSelectedItemCount(0);
      setIsFilterSelectionMode(false); // NEW: Reset filter mode when unselecting
      gridApi?.current?.paginationGoToPage(0);
      onResetBulk();
    };

    // NEW: Handle "Select All" button - shows confirmation first
    const handleSelectAll = () => {
      logger.log('🎯 Select All clicked - showing confirmation', {
        totalLeads: leadCount,
        currentFilters: filterParam
      });

      // Show confirmation modal
      setShowSelectAllConfirmation(true);
    };

    // NEW: Confirm and activate filter-based selection mode
    const confirmSelectAll = () => {
      logger.log('✅ User confirmed Select All');

      // Clear any manual selections
      if (gridApi?.current) {
        gridApi.current.deselectAll();
      }

      // Activate filter mode (this enables backend filter-based operations)
      setIsFilterSelectionMode(true);

      // Close confirmation modal
      setShowSelectAllConfirmation(false);

      toast.success(`Selected all visible leads. All ${leadCount} matching leads will be affected by bulk actions.`, {
        duration: 4000,
        icon: '✅'
      });
    };

    const onRowSelected = (event: any) => {
      if (event.node.selected) {
        setSelectedItemCount((prev: number) => prev + 1);
      } else {
        setSelectedItemCount((prev: number) => (prev === 0 ? 0 : prev - 1));
      }
    };

    const getSelectedLeadIds = () => {
      const selectedNodes: any = gridApi?.current?.getSelectedNodes();

      return selectedNodes?.map((e: any) => e.data._id);
    };

    const onDeleteLead = async () => {
      try {
        let payload: any = {};

        if (isFilterSelectionMode) {
          // Filter mode: Send complete filterParams (backend will handle pagination)
          payload.filterParams = filterParam;

          logger.log('🗑️ Delete with filterParams:', {
            filterParams: filterParam,
            totalAffected: leadCount
          });
        } else {
          // Manual mode: Send leadIDs (existing behavior)
          payload.leadIDs = getSelectedLeadIds();

          logger.log('🗑️ Delete with manual selection:', {
            selectedCount: payload.leadIDs.length
          });
        }

        const response = await deleteBulkLeads(payload);
        toast.success(response?.data?.message || 'Leads deleted successfully');
        reloadLeads();

        // Reset filter mode if it was active
        if (isFilterSelectionMode) {
          setIsFilterSelectionMode(false);
        }
      } catch (error) {
        logger.error('❌ Delete operation failed:', error);
        toast.error('Failed to delete leads. Please try again.');
      }
    };

    const handleAssignLead = async (assignToUser: string) => {
      try {
        let payload: any = {
          assignToUser
        };

        if (isFilterSelectionMode) {
          // Filter mode: Send complete filterParams (backend will handle pagination)
          payload.filterParams = filterParam;

          logger.log('👥 Assign with filterParams:', {
            assignToUser,
            filterParams: filterParam,
            totalAffected: leadCount
          });
        } else {
          // Manual mode: Send leadIds (existing behavior)
          payload.leadIds = getSelectedLeadIds();

          logger.log('👥 Assign with manual selection:', {
            assignToUser,
            selectedCount: payload.leadIds.length
          });
        }

        const { data } = await assignLeadInList(payload);
        toast.success(data?.message || 'Leads assigned successfully');
        reloadLeads();

        // Reset filter mode if it was active
        if (isFilterSelectionMode) {
          setIsFilterSelectionMode(false);
        }
      } catch (error) {
        Logger.log("err", error);
        toast.error('Failed to assign leads. Please try again.');
      }
    };

    const handleCopyLead = async (
      targetListId: string,
      activeLeadOption: string,
      useFilter: boolean = false // NEW: Flag to determine if we should use filterParams
    ) => {
      try {
        // Build the payload based on selection mode
        const data: any = {
          targetListId: targetListId === "" ? null : targetListId, // Handle default list case
        };

        if (useFilter) {
          // Filter mode: Send complete filterParams (backend will handle pagination)
          data.filterParams = filterParam;

          logger.log('📋 Copy/Move with filterParams:', {
            operation: activeLeadOption,
            targetListId,
            filterParams: filterParam,
            totalAffected: leadCount
          });
        } else {
          // Manual mode: Send selected leadIDs (existing behavior)
          data.leadIDs = getSelectedLeadIds();
          logger.log('📋 Copy/Move with manual selection:', {
            operation: activeLeadOption,
            targetListId,
            selectedCount: data.leadIDs.length
          });
        }

        if (activeLeadOption == "copy") {
          const response = await copyLeadInList(data);
          toast.success(response?.data?.message || 'Leads copied successfully');
        } else {
          const response = await moveLeadInList(data);
          toast.success(response?.data?.message || 'Leads moved successfully');
        }

        reloadLeads();

        // Reset filter mode if it was active
        if (isFilterSelectionMode) {
          setIsFilterSelectionMode(false);
        }
      } catch (err) {
        logger.error('❌ Copy/Move operation failed:', err);
        toast.error('Operation failed. Please try again.');
      }
    };
    const onRowClicked = (event: any) => {
      Logger.log('Click Event Details:', {
        hasNode: !!event.node,
        rowIndex: event.rowIndex,
        dataPresent: !!event.data,
        rowID: event.node?.id,
        currentPage: gridApi.current?.paginationGetCurrentPage()
      });
      
      if (onRowClicked && event.data) {
        onRowClicked(event.data);
      }
    };
    
    const handleSelectAutomate = async (automationId: string) => {
      try {
        const data = {
          leadIds: getSelectedLeadIds(),
          automationId,
        };

        const response = await setManuallyAutomate(data);
        toast.success(response?.data?.message);

        reloadLeads();
      } catch (err) {}
    };

    const reloadLeads = () => {
      gridApi.current?.refreshCells({ force: true });
      fetchLeadsWrapper();
    };

    const onCreateCampaign = () => {
      try {
        if (isFilterSelectionMode) {
          // Filter mode: Pass complete filterParams to broadcast page (backend will handle pagination)
          logger.log('📢 Creating campaign with filterParams:', {
            filterParams: filterParam,
            totalAffected: leadCount
          });

          // Navigate with filter params - broadcast page will include in campaign payload
          navigate("/createWhatsappBroadcast", {
            state: {
              filterParams: filterParam,
              leadCount: leadCount
            }
          });

          // Exit filter mode
          setIsFilterSelectionMode(false);
        } else {
          // Manual mode: Use selected lead IDs (existing behavior)
          const leadIds = getSelectedLeadIds();

          if (leadIds.length === 0) {
            toast.error('No leads selected for campaign');
            return;
          }

          logger.log('📢 Creating campaign with manual selection:', {
            selectedCount: leadIds.length
          });

          dispatch(setLeadIds(leadIds));
          navigate("/createWhatsappBroadcast");
        }

        reloadLeads();
      } catch (error) {
        logger.error('❌ Create campaign operation failed:', error);
        toast.error('Failed to create campaign. Please try again.');
      }
    };

    return (
      <>
    
      

{/* Bulk selector - appears when in bulk mode or items selected */}
{(showBulk || selectedItemCount > 0 || isFilterSelectionMode) && (
  <div style={{
    marginTop: 0,
    position: "relative",
    top: "10px",
    marginBottom: 20,
  }}>
    <BulkSelector
      selected={selectedItemCount}
      onSelect={handleSelection}
      onSelectAll={handleSelectAll} // NEW: Wire up Select All handler
      onReset={handleUnSelect}
      totalInFilter={leadCount} // NEW: Pass total leads in current filter
      isFilterMode={isFilterSelectionMode} // NEW: Pass filter mode state
    />
  </div>
)}

{/* Bulk action options - now also appears when in bulk mode or filter mode */}
{(showBulk || selectedItemCount > 0 || isFilterSelectionMode) && (
  <BulkLeadOptions
  onDeleteLead={onDeleteLead}
  handleAssignLead={handleAssignLead}
  handleCopyLead={handleCopyLead}
  onEditStatus={onEditStatus}
  onEditLabel={() => onEditLabel()}
  onBulkTask={() => {
    setOpenWithHeader(true);
    setAction("addTask");
  }}
  onCreateCampaign={onCreateCampaign}
  handleSelectAutomate={handleSelectAutomate}
  onExportLeads={handleExportLeads}
  onBulkShare={handleBulkShare}
  isFilterMode={isFilterSelectionMode} // NEW: Pass the filter mode flag
/>
)}
     
     {showBulkShareModal && (
      <BulkShareModal
        isOpen={showBulkShareModal}
        onClose={() => setShowBulkShareModal(false)}
        selectedLeads={selectedLeadsForShare}
        contentTemplates={contentTemplates}
      />
)}
        {/* Main grid container - scrollable */}
        <div style={{ 
      height: 'calc(100% - 48px)', // Account for pagination height
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        height: '100%',
        width: '100%',
        overflow: 'auto'
      }}>
<AgGrid
  columnDefs={columnDefs}
  fetchData={fetchLeadListOnScroll}
  onRowClick={handleRowClick}
  defaultData={leadListData}
  totalRows={leadCount}
  isLoading={isLoading}
  onColumnOrderChanged={(newColumnOrder) =>
    debouncedColumnMove(newColumnOrder, preferenceRef.current as PreferenceI)
  }
  onColumnWidthChanged={(columnId, newWidth) =>
    debouncedColumnWidth(columnId, newWidth, preferenceRef.current)
  }
  key={resetGrid}
  onGridReady={onGridReady}
  onRowSelected={onRowSelected}
  suppressPaginationPanel={false}
  pagination={true}
  paginationPageSize={50}
  context={gridContext}

/>
</div>
</div>
    
{showBulkShareModal && (
  <BulkShareModal
    isOpen={showBulkShareModal}
    onClose={() => setShowBulkShareModal(false)}
    selectedLeads={selectedLeadsForShare}
    contentTemplates={contentTemplates}
  />
)}
       
    
        {/* Task drawer */}
        <TaskDrawer
          openWithHeader={openWithHeader}
          setOpenWithHeader={setOpenWithHeader}
          onTaskDelete={() => {}}
          showDelete={false}
          drawerTitle={action === "addTask" ? "Add Task" : "Add Note"}
          size="xs"
        >
          {action === "addTask" && (
            <CreateLeadDetailsTaskForm
              leadIds={getSelectedLeadIds()}
              action="add"
              drawerClose={() => {
                setOpenWithHeader(false);
                setAction("");
                handleUnSelect();
              }}
              fetchTaskStatusFollowUps={() => {}}
            />
          )}
    
          {action === "addNotes" && (
            <CreateNoteForm
              leadIds={[{ id: leadId }]}
              handleNotesSubmit={() => {
                setOpenWithHeader(false);
                setAction("");
              }}
            />
          )}
        </TaskDrawer>
        {statusEditLead && (
  <SelectLeadStatus
    showStatusPopup={showStatusPopup}
    toggleLeadStatus={toggleStatusPopup}
    onStatusChange={(e) => setSelectedStatus(e.target.value)}
    selectedStatus={selectedStatus}
    setShowStatusPopup={setShowStatusPopup}
    from="grid"
    id={statusEditLead._id}
    leadList={StoreData?.leadName?.leadName?.id || "0"}
    getLeads={() => {}}
    setOpenWithHeader={() => {}} 
    updateEditedRow={handleStatusUpdate}
  />
)}

{showDistributionChart && (
  <PopupComponent
    isOpen={showDistributionChart}
    onClose={closeDistributionChart}
    title="Distribution Analysis"
    size="lg"
  >
    <DistributionChart 
      field={distributionField}
      filterParams={{
        ...filterParam,
        // Add the list ID to match the grid's filter behavior
        ...(StoreData.leadName.leadName.id && StoreData.leadName.leadName.id !== "0" 
          ? { list: StoreData.leadName.leadName.id } 
          : {})
      }}
    />
  </PopupComponent>
)}

{labelEditLead && (
  <SelectLeadLabel
    showLabelPopup={showLabelPopup}
    toggleLeadLabel={toggleLabelPopup}
    onLabelChange={(e) => {
      if (!e?.target?.value) return;
      
      let newLabels = [...selectedLabel];
      const value = e.target.value;
      
      if (selectedLabel.includes(value)) {
        // Remove if already included
        newLabels = newLabels.filter(label => label !== value);
      } else {
        // Add if not included
        newLabels.push(value);
      }
      
      setSelectedLabel(newLabels);
    }}
    selectedLabel={selectedLabel}
    onLeadUpdate={(lead) => {}}
    setShowLabelPopup={setShowLabelPopup}
    from="grid"
    id={labelEditLead._id}
    leadList={StoreData?.leadName?.leadName?.id || "0"}
    getLeads={() => {}}
    setOpenWithHeader={() => {}} 
    LabelData={StoreData?.user?.userPreferences?.labels || []}
    updateEditedRow={handleLabelUpdate}
  />
)}
\{/* Add this at the end of your return statement in LeadsGrid */}

{productPickerOpen && selectedLeadForProducts && (
  <MemoizedProductPickerPopup
    key={`product-picker-${selectedLeadForProducts._id}`}
    isOpen={productPickerOpen}
    onClose={() => {
      logger.log("Closing product picker");
      setProductPickerOpen(false);
      setSelectedLeadForProducts(null);
    }}
    onProductsSelect={handleProductsSelect}
    initialSelectedProducts={selectedProducts}
    selectedProductIds={selectedProductIds} // Add this line
    excludeProductIds={[]}
    leadId={selectedLeadForProducts._id}
    leadName={selectedLeadForProducts.name}
    source="lead" 
  />
)}
{showAssignDrawer && (
  <AssignLeadDrawer
    isOpen={showAssignDrawer}
    onClose={() => setShowAssignDrawer(false)}
    leadIds={selectedLeadsForAssign}
    onAssignSuccess={(assignedToUserId, affectedLeadIds) => {
      // Update the leads in Redux store
      if (affectedLeadIds && affectedLeadIds.length > 0) {
        // Find each affected lead in the grid
        gridApi.current?.forEachNode(node => {
          if (node.data && affectedLeadIds.includes(node.data._id)) {
            // Create updated lead with new assignedTo value
            const updatedLead = {
              ...node.data,
              assignedTo: assignedToUserId
            };
            
            // Dispatch updateSingleLead action to update Redux
            dispatch(updateSingleLead(updatedLead));
            
            // Also update the grid data directly for immediate UI feedback
            node.setData(updatedLead);
          }
        });
      }
      
      // Close the drawer
      setShowAssignDrawer(false);
    }}
  />
)}

{/* Inline Editor */}
<InlineEditorManager
  isOpen={inlineEditorOpen}
  leadId={inlineEditorData?.leadId || ''}
  fieldConfig={inlineEditorData?.fieldConfig || {}}
  currentValue={inlineEditorData?.currentValue}
  onSave={handleCellValueChange}
  onClose={() => {
    setInlineEditorOpen(false);
    setInlineEditorData(null);
  }}
  targetElement={inlineEditorData?.targetElement}
  initialPosition={inlineEditorData?.position}
/>

{/* Select All Confirmation Modal */}
<GenericConfirmationModal
  showModal={showSelectAllConfirmation}
  onConfirmation={confirmSelectAll}
  toggleModal={() => setShowSelectAllConfirmation(false)}
  title="Select All Leads"
  message={`You are about to select all ${leadCount} leads matching your current filters.

This means any bulk action (Copy, Move, Delete, Assign, Update Status/Labels) will affect ALL ${leadCount} leads, not just the ones visible on this page.

Are you sure you want to continue?`}
  confirmText="Yes, Select All"
  cancelText="Cancel"
  isWarning={false}
/>

      </>
    );
  }
);

export default LeadsGrid;
